__turbopack_context__.v({
  "checkbox": "Checkbox-module__mtS6Oa__checkbox",
  "checkmark": "Checkbox-module__mtS6Oa__checkmark",
  "container": "Checkbox-module__mtS6Oa__container",
  "label": "Checkbox-module__mtS6Oa__label",
  "root": "Checkbox-module__mtS6Oa__root",
});
